module.exports = __webpack_public_path__ + "static/media/logo-tekweld.5fca0570.png";